import { ClockOutlineIcon } from '@rsos/assets/icons';
import { Text, Box } from '@rsos/base-components';
import { EventShare } from '@rsos/reduxDataStore/src/features/eventShare/types';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';
import { getEventShareCount, getStatusDisplayName } from '../utils';
import { StatusIndicator } from './EventShareAccordion.styles';

const EventShareAccordionHeader = ({ share }: { share: EventShare }) => {
  const isShareLink = share.share_type === 'link';

  return (
    <Box>
      {isShareLink ? (
        <Box horizontal flow={4} align="center" mb="6px">
          <Text size="normal" color="primaryText">
            Shared via Link
          </Text>
        </Box>
      ) : (
        <Text size="normal" color="primaryText" mb="6px">
          Shared with {getEventShareCount(share)} Recipients
        </Text>
      )}
      <Box align="center" flow={4} horizontal mb="4px">
        <StatusIndicator status={share.status} />
        <Text size="small" color="primaryText">
          {getStatusDisplayName(share.status)}
        </Text>
      </Box>
      <Box horizontal flow={4} color="secondaryText" align="center">
        <ClockOutlineIcon width={10} height={10} />
        <Box align="center">
          <Text size="small">
            Link expires: {convertUnixTimestamp(share.expiry)} - Shared by{' '}
            {share.shared_by?.name || 'Unknown User'}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default EventShareAccordionHeader;
